<template>
  <v-card
    :href="programAlert.url"
    class="bg-secondary-extra-light px-0 mt-4 mb-0"
    border
    flat
    tile
  >
    <v-card-text class="pb-0">
      <v-row dense>
        <v-col
          v-if="display.mdAndUp && programAlert.logo"
          class="d-flex align-stretch pt-4 px-4"
          cols="3"
        >
          <img
            :src="programAlert.logo"
            alt="Image of children playing"
          />
        </v-col>
        <v-col class="pa-4">
          <h1
            v-if="programAlert.title"
            class="c-primary fs-22 fw-600 mb-2"
          >
            {{ $bct(programAlert.title) }}
          </h1>
          <div
            v-if="programAlert.description"
            class="fs-16 fw-500"
          >
            {{ $bct(programAlert.description) }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-0 mnh-0">
      <v-btn
        :aria-label="
          [$bct(programAlert.title), $bct(programAlert.description), $bct(title)].join(', ')
        "
        class="d-flex align-center focus-very-visible justify-space-between"
        color="secondary"
        height="unset"
        max-width="1"
        min-height="40"
        block
        tile
      >
        <span
          class="fw-600 fs-22 text-wrap"
          data-cy="apply_workflow"
        >
          {{ $bct(title) }}
        </span>
        <template #append>
          <v-icon
            class="fs-28"
            icon="arrow_circle_right"
          />
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';

const $bct = inject('translator');

defineProps({
  route: {
    type: Object,
    default: null,
  },
});

const store = useStore();
const display = useDisplay();

const programAlert = computed(() => store.state.pages.Search.program_alert);
const title = computed(() => programAlert.value.cta || 'Learn more and apply');
</script>
